import type { Ref } from 'react';

/**
 * A component that uses the `dangerouslySetInnerHTML` attribute behind the scenes to render raw HTML
 * Please use this component only with safe and trusted HTML
 *
 * @param {string} markup The HTML Markup to render
 * @param {string} className Optional className to the parent element
 */

type HtmlProps = {
    markup?: string;
    className?: string;
    ref?: Ref<HTMLDivElement>;
};

export const Html = ({
    markup = '',
    className = undefined,
    ref = undefined,
}: HtmlProps) => (
    <div
        ref={ref}
        className={className}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: markup }}
    />
);
